import Fuse from 'fuse.js'
import { markRaw } from 'vue'

import Model from '../model'
import Result from '../result'

import Component from '@/components/search/elements/Customer.vue'
import { useCustomerStore } from '~/stores/useCustomerStore'

class Customer extends Model {
  constructor (options = {}) {
    super(options)

    this.name = 'Customer'
    this.component = Component

    this.items = []
    this.fuse = null
    this.initPromise = null
  }

  init () {
    const customerStore = useCustomerStore()

    // Make the current in-memory cache searchable immediately. Refreshing is
    // intentionally background work so opening the overlay never waits for
    // IndexedDB or the API.
    this.items = customerStore.all
    this.fuse = null

    if (this.initPromise) return this.initPromise

    this.syncing = true
    this.initPromise = customerStore.sync()
      .then(() => {
        this.items = customerStore.all
        this.fuse = null
      })
      .catch((error) => {
        console.error('Error syncing customers for search:', error)
      })
      .finally(() => {
        this.syncing = false
        this.initPromise = null
      })

    return this.initPromise
  }

  search (query) {
    if (!this.fuse) {
      this.fuse = markRaw(new Fuse(this.items, {
        keys: [
          {
            name: 'displayName',
            weight: 2,
          },
          'email',
          'phone',
        ],
        threshold: 0.3,
      }))
    }

    const results = this.fuse.search(query)
    const filtered = results.map(({ item }) => new CustomerResult({ data: item }))

    filtered.length = Math.min(filtered.length, 5)

    this.results = filtered
  }
}

class CustomerResult extends Result {
  get path () {
    return '/customer/' + this.data.idCustomer
  }
}

export default new Customer()
